import * as Yup from 'yup';
import {
  type CountryCode,
  parsePhoneNumberFromString,
} from 'libphonenumber-js';
import { countryPhoneCodes } from '@/utils/constants/countryPhoneCodes';

const getPhoneCountryCodeObject = (
  option: { value: string } | string | null,
) => {
  const countryCode = typeof option === 'string' ? option : option?.value;
  return countryPhoneCodes.find(
    ({ code, dial_code }) => code === countryCode || dial_code === countryCode,
  );
};

const getPhoneValidator = (countryCodeName: string) => {
  return Yup.string()
    .required()
    .test(
      'invalid-phone-number',
      { key: 'form.validation.invalidPhoneNumber' },
      function (phoneNumber, testContext) {
        // If not yet filled, do not validate
        if (!phoneNumber) {
          return true;
        }

        const phoneCountryCode = getPhoneCountryCodeObject(
          testContext.parent[`${countryCodeName}_countryCode`],
        );

        const parsedPhoneNumber = parsePhoneNumberFromString(
          phoneNumber,
          phoneCountryCode?.code as CountryCode,
        );

        // If it failed to parse, then it's not a valid phone number
        if (!parsedPhoneNumber) {
          return false;
        }

        return parsedPhoneNumber.isValid();
      },
    );
};

const registerSchema = () =>
  Yup.object({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
    confirmPassword: Yup.string()
      .required()
      .test(
        'passwords-match',
        { key: 'form.validation.passwordsMustMatch' },
        function (value) {
          return this.parent.password === value;
        },
      ),
  });

export const registerInvitationSchema = () =>
  registerSchema().concat(
    Yup.object({
      phoneNumber: getPhoneValidator('phoneNumber').required(),
    }),
  );

export type RegisterSchemaType = Yup.InferType<
  ReturnType<typeof registerInvitationSchema>
>;

export default registerSchema;
